<template>
	<div id="app">
		<!-- 管理后台使用独立布局（自带暗色侧边栏） -->
		<router-view v-if="isAdminPage && isRouterAlive"></router-view>
		<Layout v-else class="app-frame" :siderCollapsed="sliderCollapsed" :siderFixed="layoutConfig.siderFixed">
			<Sider :theme="layoutConfig.siderTheme">
				<appMenu :theme="layoutConfig.siderTheme"></appMenu>
			</Sider>
			<Layout :headerFixed="layoutConfig.headerFixed">
				<HHeader theme="white">
					<appHead @openSetting="openSetting=true" :layoutConfig="layoutConfig"></appHead>
				</HHeader>
				<SysTabs v-if="layoutConfig.showSystab" homePage="Home"></SysTabs>
				<Content>
					<div class="app-frame-content ">
						<router-view v-if="isRouterAlive"></router-view>
					</div>
					<HFooter>
						<appFooter></appFooter>
					</HFooter>
				</Content>
			</Layout>
		</Layout>
	</div>
</template>
<script>

	import appHead from './app/app-header';
	import appMenu from './app/app-menu';
	import appFooter from './app/app-footer';
	import {mapState} from 'vuex';
	import SysTabs from './app/sys-tabs/sys-tabs';

	export default {
		name: "FXY",
		provide() {
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				openSetting: false,
				isRouterAlive: true,
				layoutConfig: {
					siderTheme: 'dark',
					showSystab: false,
					headerFixed: true,
					siderFixed: true
				}
			};
		},
		methods: {
			updateLayoutConfig({key, value}) {
				this.layoutConfig[key] = value;
			},
			reload() {
				this.isRouterAlive = false;
				this.$nextTick(() => {
					this.isRouterAlive = true;
				});
			},
			//展示未读的系统公告（服务端按用户过滤已读，换设备也不会重复弹）
			showAnnouncements() {
				this.$api.common.activeAnnouncements().then(({data}) => {
					let list = data || [];
					if (!list.length) {
						return;
					}
					list.forEach(a => {
						this.$Notice({
							type: 'info',
							title: (a.type || '通知') + '：' + a.title,
							content: a.content
						});
						//展示后即标记已读
						this.$api.common.markAnnouncementRead({id: a.id}).catch(() => {
						});
					});
				}).catch(() => {
				});
			},
			//账套到期提醒：7 天内到期或已到期时登录后主动提示（每会话一次）
			checkExpireRemind() {
				if (!this.User || !this.User.accountSetsId) {
					return;
				}
				if (sessionStorage.getItem('expire_reminded_' + this.User.accountSetsId)) {
					return;
				}
				this.$api.setting.accountSets.expireInfo().then(({data}) => {
					if (!data || !data.expireDate) {
						return;
					}
					let expire = new Date(data.expireDate.replace(/-/g, '/'));
					let days = Math.ceil((expire.getTime() - Date.now()) / 86400000);
					if (days <= 7) {
						sessionStorage.setItem('expire_reminded_' + this.User.accountSetsId, '1');
						if (days < 0) {
							this.$Notice({
								type: 'error',
								title: '账套已到期',
								content: '当前账套已于 ' + data.expireDate.substring(0, 10) + ' 到期，请尽快在【账套管理】中续费，否则无法新增凭证等操作。'
							});
						} else {
							this.$Notice({
								type: 'warning',
								title: '账套即将到期',
								content: '当前账套将于 ' + data.expireDate.substring(0, 10) + ' 到期（剩余 ' + days + ' 天），请提前在【账套管理】中续费。'
							});
						}
					}
				}).catch(() => {
				});
			}
		},
		computed: {
			...mapState(['sliderCollapsed', 'User']),
			isAdminPage() {
				return this.$route.path.indexOf('/admin') === 0;
			}
		},
		components: {
			appHead,
			appMenu,
			appFooter,
			SysTabs
		},
		mounted() {
			this.showAnnouncements();
			this.checkExpireRemind();
		}
	};
</script>
